import React from 'react';
import { Alert as AntdAlert, type AlertProps as AntdAlertProps } from 'antd';

export type Severity = 'info' | 'warning' | 'error' | 'success';

export type AlertBannerProps = Omit<AntdAlertProps, 'type'> & {
    severity?: Severity;
};

type AlertBannerRef = React.ComponentRef<typeof AntdAlert>;

type AlertBannerComponent = React.ForwardRefExoticComponent<
    AlertBannerProps & React.RefAttributes<AlertBannerRef>
>;

const AlertBanner = React.forwardRef<AlertBannerRef, AlertBannerProps>(
    ({ severity = 'info', showIcon = true, ...props }, ref) => (
        <AntdAlert ref={ref} type={severity} showIcon={showIcon} {...props} />
    ),
) as AlertBannerComponent;

AlertBanner.displayName = 'AlertBanner';

export { AntdAlert };
export default AlertBanner;
